// extracted by mini-css-extract-plugin
export default {"social-links":"social-links--mp-HqDLo","socialLinks":"social-links--mp-HqDLo"};